import { Component, OnInit, NgZone } from '@angular/core';
import { ProductsService } from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-products-elabel-history',
  templateUrl: './products-elabel-history.component.html',
  styleUrls: ['./products-elabel-history.component.scss'],
})
export class ProductsElabelHistoryComponent implements OnInit {
  listELabelHistory: any = [];
  total: any = 0;
  loading: any = false;
  page: any = 1;
  pageSize: any = 10;
  productId: any = null;
  unsubscribe$ = new Subject<void>();

  isDetailModalVisible = false;
  logChanges: any[] = [];

  constructor(
    private notification: NzNotificationService,
    private productService: ProductsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.productId = window.location.href.split('/')[5];
    this.getListELabelHistory();
  }

  getListELabelHistory() {
    const query = {
      page: this.page,
      pageSize: this.pageSize,
      productId: this.productId,
    };
    this.loading = true;
    this.productService
      .getELabelLogs(this.productId, query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          if (res.code === 1) {
            if (res.data && res.data.items) {
              this.listELabelHistory = [...res.data.items];
              this.total = res.data.totalElement;
            }
          } else {
            this.notification.warning(
              'Có lỗi xảy ra',
              res.message || 'Vui lòng thử lại'
            );
          }
          this.loading = false;
        },
        (error: any) => {
          this.notification.error(
            'Có lỗi xảy ra',
            error || 'Vui lòng thử lại'
          );
          this.loading = false;
        }
      );
  }

  showELabelHistoryDetail(item: any) {
    this.productService
      .getELabelLogDetail(this.productId, item.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: any) => {
          if (res.code === 1 && res.data) {
            this.parseLogChanges(res.data);
            this.isDetailModalVisible = true;
          } else {
            this.notification.warning('Có lỗi xảy ra', res.message || 'Không lấy được chi tiết');
          }
        },
        (error: any) => {
          this.notification.error('Có lỗi xảy ra', 'Không lấy được chi tiết lịch sử E-Label');
        }
      );
  }

  parseLogChanges(data: any) {
    let oldAttrs: any[] = [];
    let newAttrs: any[] = [];

    const getParsedData = (raw: any) => {
      if (!raw) return null;
      if (typeof raw === 'string') {
        try { return JSON.parse(raw); } catch (e) { console.error('Error parsing raw data', e); return null; }
      }
      return raw;
    };

    const extractAttrs = (parsed: any) => {
      if (!parsed) return [];
      if (parsed.attribute_data) {
        let attrData = parsed.attribute_data;
        if (typeof attrData === 'string') {
          try { attrData = JSON.parse(attrData); } catch (e) { console.error('Error parsing attribute_data', e); attrData = []; }
        }
        if (Array.isArray(attrData)) {
          return attrData;
        }
      }
      return [];
    };

    const isCheckboxVisible = (attr: any) => {
      if (!attr || attr.value_type !== 'checkbox') return true;

      // Kiểm tra có textInput không — nếu có thì luôn hiển thị
      try {
        const parsedVal = typeof attr.value === 'string' ? JSON.parse(attr.value) : attr.value;
        if (parsedVal && typeof parsedVal === 'object' && !Array.isArray(parsedVal)) {
          if (parsedVal.textInput !== undefined && parsedVal.textInput !== null && String(parsedVal.textInput).trim() !== '') {
            return true;
          }
        }
      } catch (e) { }

      // Không có textInput → kiểm tra checked
      let isChecked = false;
      if (attr.checked === true || String(attr.checked) === 'true') isChecked = true;

      if (!isChecked && attr.value) {
        try {
          const parsedVal = typeof attr.value === 'string' ? JSON.parse(attr.value) : attr.value;
          if (Array.isArray(parsedVal)) {
            isChecked = parsedVal.some(item => item.checked === true || String(item.checked) === 'true');
          } else if (parsedVal && typeof parsedVal === 'object') {
            if (parsedVal.checked === true || String(parsedVal.checked) === 'true') {
              isChecked = true;
            } else if (Array.isArray(parsedVal.options)) {
              isChecked = parsedVal.options.some((o: any) => o.checked === true || String(o.checked) === 'true');
            }
          }
        } catch (e) { }
      }
      return isChecked;
    };

    oldAttrs = extractAttrs(getParsedData(data.oldData));
    newAttrs = extractAttrs(getParsedData(data.newData));

    console.log('[DEBUG] oldAttrs:', JSON.stringify(oldAttrs, null, 2));
    console.log('[DEBUG] newAttrs:', JSON.stringify(newAttrs, null, 2));
    console.log('[DEBUG] checkbox items old:', oldAttrs.filter((a: any) => a.value_type === 'checkbox'));
    console.log('[DEBUG] checkbox items new:', newAttrs.filter((a: any) => a.value_type === 'checkbox'));

    this.logChanges = [];
    const maxLength = Math.max(oldAttrs.length, newAttrs.length);

    for (let i = 0; i < maxLength; i++) {
      const oldItem = oldAttrs[i];
      const newItem = newAttrs[i];

      const oldValParsed = oldItem ? (oldItem.value_type === 'checkbox' && !isCheckboxVisible(oldItem) ? '' : this.formatValue(oldItem.value, oldItem.value_type)) : '';
      const newValParsed = newItem ? (newItem.value_type === 'checkbox' && !isCheckboxVisible(newItem) ? '' : this.formatValue(newItem.value, newItem.value_type)) : '';

      const getCheckboxTitle = (item: any) => {
        if (!item || item.value_type !== 'checkbox') return '';
        try {
          const parsed = typeof item.value === 'string' ? JSON.parse(item.value) : item.value;
          if (parsed && parsed.textInput) return parsed.textInput;
        } catch (e) { }
        return item.title || item.name || '';
      };

      const oldName = oldItem ? oldItem.title : '';
      const newName = newItem ? newItem.title : '';

      this.logChanges.push({
        oldAttributeName: oldName,
        oldValue: oldValParsed,
        newAttributeName: newName,
        newValue: newValParsed
      });
    }
  }

  formatValue(val: any, valType?: string): string {
    if (val === null || val === undefined || val === '') return '';
    if (typeof val !== 'string') {
      try { val = JSON.stringify(val); } catch (e) { return String(val); }
    }

    try {
      const parsed = JSON.parse(val);
      if (typeof parsed === 'object' && parsed !== null) {

        const renderOptions = (options: any[]) => {
          let html = `<table class="options-table">`;

          const titles: string[] = [];
          const columnData: Record<string, any[]> = {};

          options.forEach(o => {
            const t = (o.title !== undefined && o.title !== null) ? String(o.title) : '';
            if (!titles.includes(t)) {
              titles.push(t);
              columnData[t] = [];
            }
            columnData[t].push(o.content !== undefined ? o.content : '');
          });

          if (titles.length === 0) return '';

          html += `<thead><tr>`;
          titles.forEach(t => {
            html += `<th>${t}</th>`;
          });
          html += `</tr></thead>`;

          html += `<tbody>`;
          let maxRows = 0;
          titles.forEach(t => {
            if (columnData[t].length > maxRows) maxRows = columnData[t].length;
          });

          for (let i = 0; i < maxRows; i++) {
            html += `<tr>`;
            titles.forEach(t => {
              const cellVal = columnData[t][i] !== undefined ? columnData[t][i] : '';
              html += `<td>${cellVal}</td>`;
            });
            html += `</tr>`;
          }
          html += `</tbody>`;

          html += `</table>`;
          return html;
        };

        if (Array.isArray(parsed)) {
          const isComplex = parsed.some(item => typeof item === 'object' && item !== null && item.title !== undefined);
          if (isComplex) {
            return `<div class="history-complex-val">${renderOptions(parsed)}</div>`;
          }
          const mapped = parsed.map(item => {
            if (typeof item === 'object' && item !== null) {
              return item.value || item.name || item.title || JSON.stringify(item);
            }
            return item;
          });
          return mapped.join(', ');
        }

        if (valType === 'dropdown') {
          let res = `<div class="history-complex-val">`;
          res += `<div class="text-input" style="margin-bottom: 8px;">${parsed.name || ''}</div>`;
          if (parsed.dataType === 'default_value') {
            res += `<div style="color: #666; margin-top: 4px;">${parsed.description || ''}</div>`;
          } else if (parsed.valueMore !== undefined && parsed.valueMore !== null) {
            res += `<table class="options-table">`;
            if (parsed.description) {
              res += `<thead><tr><th>${parsed.description}</th></tr></thead>`;
            }
            res += `<tbody><tr><td>${parsed.valueMore}</td></tr></tbody>`;
            res += `</table>`;
          }
          res += `</div>`;
          return res;
        }

        if (parsed.textInput !== undefined) {
          let res = `<div class="history-complex-val"><div class="text-input">${parsed.textInput}</div>`;
          // Chỉ hiển thị bảng options khi checkbox đã được checked
          const isChecked = parsed.checked === true || String(parsed.checked) === 'true';
          if (isChecked && parsed.options && Array.isArray(parsed.options) && parsed.options.length) {
            res += `<div class="text-input">${parsed.defaultVal}</div>`
            res += renderOptions(parsed.options);
          } else if (isChecked && (!parsed.options || parsed.options.length === 0) && parsed.defaultVal) {
            res += `<div class="text-input">${parsed.defaultVal}</div>`;
          }
          res += `</div>`;
          return res;
        }

        if (parsed.value !== undefined) return String(parsed.value);
        if (parsed.name !== undefined) return String(parsed.name);

        return `<pre style="white-space: pre-wrap; word-break: break-word; margin: 0; background: transparent; border: none; padding: 0;">${JSON.stringify(parsed, null, 2)}</pre>`;
      }
      return String(parsed);
    } catch (e) {
      return String(val);
    }
  }

  closeDetailModal() {
    this.isDetailModalVisible = false;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
